export default "__VITE_ASSET__CApumu65__"